import store from '../redux/store';

import {
  addGlobalMsg,
  updateCurrentGlobalMsg,
} from 'web/redux/slices/MessageSlice';

/**
 * Show a message modal
 * @param {String} mode Message mode (error, warning, info)
 * @param {String} title Message title
 * @param {String} message Message content
 */
const showMessage = (mode, title, message = '', disabled = false) => {
  return store.dispatch(addGlobalMsg({mode, title, message, disabled}));
};

const updateCurrentMsg = (mode, title, message = '', disabled = false) => {
  return store.dispatch(
    updateCurrentGlobalMsg({mode, title, message, disabled}),
  );
};

export {showMessage, updateCurrentMsg};
